import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  ConverterService,
  InterceptorUtil,
  OCC_USER_ID_ANONYMOUS, OCC_USER_ID_GUEST,
  Occ, OccEndpointsService,
  USE_CLIENT_TOKEN
} from '@spartacus/core';
import { OccOrderHistoryAdapter } from '@spartacus/order/occ';
import { ORDER_HISTORY_NORMALIZER, ORDER_NORMALIZER, Order, OrderHistoryList } from '@spartacus/order/root';
import { Observable } from 'rxjs';
import { OrdersFilter } from '../../../../model/order-filters.model';
import { CustomUserOrderAdapter } from '../../../user/connectors/order/custom-user-order.adapter';

@Injectable()
export class CustomOccUserOrderAdapter extends OccOrderHistoryAdapter implements CustomUserOrderAdapter {

  constructor(http: HttpClient, occEndpoints: OccEndpointsService, converter: ConverterService, private router: Router) {
    super(http, occEndpoints, converter)
  }

  public load(userId: string, orderCode: string): Observable<Order> {
    let headers = new HttpHeaders();
    if (userId === OCC_USER_ID_ANONYMOUS) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);
    }
    const url = this.occEndpoints.buildUrl('orderDetail', {
      urlParams: {
        userId,
        orderId: orderCode,
      }
    });

    return this.http
      .get<Occ.Order>(url, { headers })
      .pipe(this.converter.pipeable(ORDER_NORMALIZER));
  }


  public loadHistoryFilter(
    userId: string,
    pageSize?: number,
    currentPage?: number,
    sort?: string,
    ordersFilter?: OrdersFilter,
  ): Observable<OrderHistoryList> {
    const params = {};
    if (pageSize) {
      params['pageSize'] = pageSize.toString();
    }
    if (currentPage) {
      params['currentPage'] = currentPage.toString();
    }
    if (sort) {
      params['sort'] = sort.toString();
    }

    for (const key in ordersFilter) {
      if (Object.prototype.hasOwnProperty.call(ordersFilter, key)) {
        const element = ordersFilter[key];
        if (element) {
          params[key] = element;
        }
      }
    }

    const url = this.occEndpoints.buildUrl('orderHistory', {
      urlParams: { userId },
      queryParams: params
    });

    return this.http
      .get<Occ.OrderHistoryList>(url)
      .pipe(this.converter.pipeable(ORDER_HISTORY_NORMALIZER));
  }

  public loadOrderStatusList(): Observable<any> {
    const url = this.occEndpoints.buildUrl('orderStatusList');

    return this.http.get<Occ.OrderHistoryList>(url);
  }

  public loadOrderDetail(userId: string, orderCode: string): Observable<Order> {
    let headers = new HttpHeaders();
    if (userId === OCC_USER_ID_ANONYMOUS || userId === OCC_USER_ID_GUEST) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);
    }
    let occEndpoint: string = this.router.url.includes('pedidos') ? 'myAccountOrderDetail' : 'orderDetail';
    const url = this.occEndpoints.buildUrl(occEndpoint, {
      urlParams: {
        userId,
        orderId: orderCode,
      }
    });


    return this.http
      .get<Occ.Order>(url, { headers })
      .pipe(this.converter.pipeable(ORDER_NORMALIZER));
  }

  public setOrderConfirmationChecked(
    userId: string,
    orderCode: string,
  ): Observable<Order> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    if (userId === OCC_USER_ID_ANONYMOUS || userId === OCC_USER_ID_GUEST) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);
    }
    const url = this.occEndpoints.buildUrl('setOrderChecked', {
      urlParams: {
        userId,
        orderId: orderCode,
      }
    });
    return this.http.get<Occ.Order>(url, { headers }).pipe(this.converter.pipeable(ORDER_NORMALIZER));
  }

}
